import formatTime from '@/utils/common.js';
import { Message } from 'element-ui';
import { searchFieldSeperated, validateSearchTime } from '@/modules/transport/otp/views/distributeManage/receiptCenter/search.js';
import _ from 'lodash';
import dayjs from 'dayjs';

const formatSearchData = (data) => {
    const params = _.cloneDeep(data);
    const normalizeTime = (times, startKey, endKey) => {
        try {
            const [startTime, endTime] = times || [];
            params[startKey] = startTime ? formatTime.formatDateTime(startTime) : ''
            params[endKey] = endTime ? formatTime.formatDateTime(endTime) : ''
        } catch (err) {
            console.error(err);
        }
    };

    params.customerOrderNoList = searchFieldSeperated(params.customerOrderNo || '');params.dispatchNoList = searchFieldSeperated(data.dispatchNo || '');
    params[params.batchQueryKey] = processQueryParams(params.batchQueryKey, params.batchQueryValue);
    if (params.siteName) {
        params.siteNameList = params.siteName.length ? params.siteName.split(',') : [];
        params.siteCodeList = params.siteCode.length ? params.siteCode.split(',') : [];
    }
    // if (params.carrierName) {
    //     params.carrierNameList = params.carrierName.length ? params.carrierName.split(',') : [];
    //     params.carrierCodeList = params.carrierCode.length ? params.carrierCode.split(',') : [];
    // }
    if (params.customerName) {
        params.customerNameList = params.customerName.length ? params.customerName.split(',') : [];
        params.customerCodeList = params.customerCode.length ? params.customerCode.split(',') : [];
    }
    if (params.lineName) {
        params.lineNameList = params.lineName.length ? params.lineName.split(',') : [];
        params.lineCodeList = params.lineCode.length ? params.lineCode.split(',') : [];
    }
    if (params.lineNameV1) {
        params.lineNameV1List = params.lineNameV1.length ? params.lineNameV1.split(',') : [];
        params.lineCodeV1List = params.lineCodeV1.length ? params.lineCodeV1.split(',') : [];
    }
    if (params.planCarrierName) {
        params.planCarrierNameList = params.planCarrierName.length ? params.planCarrierName.split(',') : [];
        params.planCarrierCodeList = params.planCarrierCode.length ? params.planCarrierCode.split(',') : [];
    }
    if (params.handlingCarrierName) {
        params.handlingCarrierNameList = params.handlingCarrierName.length ? params.handlingCarrierName.split(',') : [];
        params.handlingCarrierCodeList = params.handlingCarrierCode.length ? params.handlingCarrierCode.split(',') : [];
    }
    if (params.receiverProvinceName) {
        params.receiverProvinceNameList = params.receiverProvinceName.length ? params.receiverProvinceName.split(',') : [];
        params.receiverProvinceCodeList = params.receiverProvinceCode.length ? params.receiverProvinceCode.split(',') : [];
    }
    if (params.receiverCityName) {
        params.receiverCityNameList = params.receiverCityName.length ? params.receiverCityName.split(',') : [];
        params.receiverCityCodeList = params.receiverCityCode.length ? params.receiverCityCode.split(',') : [];
    }
    if (params.vehicleCard) {
        params.vehicleCardList = params.vehicleCard.length ? params.vehicleCard.split(',') : [];
    }
    if (params.driver) {
        params.driverList = params.driver.length ? params.driver.split(',') : [];
    }
    if (params.createTime && params.createTime.length) {
        params.createTimeStart = formatTime.formatDateTime(params.createTime[0]);
        params.createTimeEnd = formatTime.formatDateTime(params.createTime[1]);
    } else if (!params.createTime) {
        params.createTimeStart = '';
        params.createTimeEnd = '';
    }
    // 出库时间
    if (params.loadDate && params.loadDate.length) {
        params.loadDateStart = formatTime.formatDateTime(params.loadDate[0]);
        params.loadDateEnd = formatTime.formatDateTime(params.loadDate[1]);
    } else if (!params.loadDate) {
        params.loadDateStart = '';
        params.loadDateEnd = '';
    }
    if (params.senderAddress && params.senderAddress.length >= 3) {
        params.senderProvinceCode = params.senderAddress[0] || '';
        params.senderCityCode = params.senderAddress[1] || '';
        params.senderDistrictCode = params.senderAddress[2] || '';
    }

    normalizeTime(params.requireCarArriveTime, 'requireCarArriveTimeStart', 'requireCarArriveTimeEnd');
    normalizeTime(params.requireDepartTime, 'requireDepartTimeStart', 'requireDepartTimeEnd');
    normalizeTime(params.requireArriveTime, 'requireArriveTimeStart', 'requireArriveTimeEnd');
    normalizeTime(params.requestSignDate, 'requestSignDateStart', 'requestSignDateEnd');

    delete params.dispatchNo;
    delete params.batchQueryKey;
    delete params.batchQueryValue;
    delete params.senderAddress;
    delete params.customerOrderNo;
    delete params.createTime;
    delete params.loadDate;
    delete params.siteName;
    delete params.siteCode;
    delete params.carrierName;
    // delete params.carrierCode;
    // delete params.customerName;
    delete params.customerCode;
    delete params.planCarrierName;
    delete params.planCarrierCode;
    delete params.lineName;
    delete params.lineCode;
    delete params.lineNameV1;
    delete params.lineCodeV1;
    delete params.handlingCarrierName;
    delete params.handlingCarrierCode;
    delete params.receiverProvinceName;
    delete params.receiverProvinceCode;
    delete params.receiverCityName;
    delete params.receiverCityCode;
    delete params.vehicleCard;
    delete params.driver;
    return params;
};

/**
 * @description 校验查询条件
 * @param data 查询数据
 * @param maxSearchDay 最大查询区间
 */
const validateSearchData = (data, maxSearchDay = 31, maxNum = 100) => {
    const oddNumbersField = ['customerOrderNoList', 'taskNoList', 'jdVcList', 'consolidationOrderNoList', 'assembleNoList', 'planOrderNoList', 'waveIdList', 'dispatchNoList', 'orderNoList'];
    const batchSearchField = ['customerOrderNoList', 'taskNoList', 'jdVcList', 'consolidationOrderNoList', 'assembleNoList', 'planOrderNoList', 'waveIdList', 'dispatchNoList', 'orderNoList'];
    if (requiredVerification(data, oddNumbersField) && !data.createTimeStart) {
        Message.warning('单号、创建时间 不可同时为空');
        return false;
    }
    if (maxLengthVerification(data, batchSearchField, maxNum)) {
        Message.warning(`按照单号查询，每次最多支持查询${maxNum}单`);
        return false;
    }
    if (data.siteCodeList && data.siteCodeList.length > 5) {
        Message.warning('服务平台最多支持查询5个');
        return false;
    }
    return validateSearchTime(data, 'createTimeStart', 'createTimeEnd', maxSearchDay) &&
        validateMaxLoadDate(data, 'loadDateStart', 'loadDateEnd');
};

/**
 * @description 校验出库时间，最大7天
 * @param data 查询数据
 */
const validateMaxLoadDate = (searchData, sDateField, eDateField) => {
    if (searchData[sDateField] && searchData[eDateField]) {
        const sDateTimeStamp = new Date(searchData[sDateField]).getTime();
        const eDateTimeStamp = new Date(searchData[eDateField]).getTime();
        const maxDay = 1000 * 60 * 60 * 24 * 7;
        if (eDateTimeStamp - sDateTimeStamp > maxDay) {
            Message.warning(`按出库时间查询或导出时，查询或导出时间跨度不可超过7天`);
            return false;
        }
    }
    return true;
};

/**
 * @description 创建时间格式处理
 * @description createTime 创建时间
 * @return data 查询数据
 */
export const formatSetSearchTime = data => {
    const searchData = _.cloneDeep(data);
    // 校验时间格式是否为 YYYY-MM-DD HH:mm:ss
    const reg = /^(\d{1,4})\-(\d{1,2})\-(\d{1,2}) (\d{1,2}):(\d{1,2}):(\d{1,2})$/;
    if (searchData.createTime && !reg.test(searchData.createTime[0])) {
        searchData.createTime[0] = formatTimeData(searchData.createTime[0]);
        searchData.createTime[1] = formatTimeData(searchData.createTime[1]);
    }
    delete searchData.batchQueryKey;
    delete searchData.batchQueryValue;
    return searchData;
};

/// 将日期格式化为 2021-12-02 18:08:23 这样的格式
function formatTimeData (dateString) {
    return dayjs(dateString).format('YYYY-MM-DD HH:mm:ss');
}

const processQueryParams = (key, value) => {
    const singleQueryKeyArr = []; // 仅支持单条查询的key，本期全部支持多条查询，所以暂时为空
    if (!singleQueryKeyArr.includes(key)) {
        return searchFieldSeperated(value || '');
    } else {
        return value || '';
    }
};

const maxLengthVerification = (data, fieldList, maxNum = 100) => {
    return fieldList.some(v => data[v] && data[v].length > maxNum);
};

const requiredVerification = (data, fieldList) => {
    return fieldList.every(v => !(data[v] && data[v].length));
};

/**
 * @description 校验绑定零担号
 * @param {*} data 选中数据
 */
const validateBind = data => {
    if (!data.length) {
        Message.warning('至少选择一条数据');
        return false;
    }
    // 专业公司为零担干线，发运类型为零担，运输单状态为在途、已抵达，下发零担平台为已下发，零担平台为蓝桥或车满满，才允许绑定
    if (data.some(v => +v.professionalCompany !== 3 || +v.shippingType !== 0 || ![40, 50].includes(+v.taskStatus) || v.isIssue !== 'Y' || !['LQ', 'CMM'].includes(v.lclPlate))) {
        Message.warning('存在不符合绑定条件的运单，请重新选择！');
        return false;
    }
    if (data.some(v => v.lclNo) && data.some(v => !v.lclNo)) {
        Message.warning('存在已绑定的运单，请重新选择!');
        return false;
    }
    // 零担运单号全部相同 才允许绑定
    const ldWaybillNo = data.map(v => v.lclNo);
    if (ldWaybillNo.some(v => v !== ldWaybillNo[0])) {
        Message.warning('存在不同的零担运单号，请重新选择修改!');
        return false;
    }
    // 零担平台全部相同 才允许绑定
    const lclPlateList = data.map(v => v.lclPlate);
    if (lclPlateList.some(v => v !== lclPlateList[0])) {
        Message.warning('存在不同的零担平台的运单，请重新选择!');
        return false;
    }
    return true;
};

/**
 * @description 处理订单类型字典映射
 * @param {Obejct} dictData 字典数据
 * @param {Object} v 当前表格行数据
 */
const mapOrderTypeDictField = (dictData, v) => {
    const IS_CAI_NIAO = v.sourceSystem === 'CAINIAO'; // 来源系统是菜鸟(SOURCE_SYSTEM)
    const IS_YS = v.orderType === 'YS'; // 订单类型是纯运输订单(ORDER_TYPE)
    const SERVICE_TYPE_8 = +v.serviceType === 8; // 服务类型是8(SERVICE_TYPE_OTP), 8暂不知道是啥类型，业务要求等于8
    return IS_CAI_NIAO && IS_YS && SERVICE_TYPE_8 ? '逆向运输' : t(v.orderType, dictData, 'ORDER_TYPE');
};

/**
 * @description 格式化列表数据 -- 数据字典转换, 事件按钮控制
 * @param {*} data
 */
const formatTotalDataList = (data, dictData) => {
    if (!data.length) return [];
    data.forEach((item) => {
        item.hiddenEvent = [];
        item.taskStatusName = t(item.taskStatus, dictData, 'TRANSPORT_STATUS'); // 运输单状态
        item.shippingTypeName = t(item.shippingType, dictData, 'TMS_SHIPPING_TYPE'); // 发运类型
        item.taskTypeName = t(item.taskType, dictData, 'TASK_TYPE'); // 任务类型
        item.inOutTypeName = t(item.inOutType, dictData, 'IN_OUT_TYPE'); // 出入库类型
        item.orderTypeName = mapOrderTypeDictField(dictData, item); // 订单类型
        item.orderSourcePlatformName = t(item.orderSourcePlatform, dictData, 'ORDER_SOURCE_PLATFORM'); // 订单来源平台
        item.sourceSystemName = t(item.sourceSystem, dictData, 'SOURCE_SYSTEM'); // 来源系统
        item.businessModeName = t(item.businessMode, dictData, 'BUSINESS_MODE'); // 业务模式
        item.projectClassifyName = t(item.projectClassify, dictData, 'PROJECT_CLASSIFY'); // 项目分类
        item.planOrderFlagName = t(item.planOrderFlag, dictData, 'PLAN_ORDER_FLAG'); // 是否模糊订单
        item.businessCategoryName = t(item.businessCategory, dictData, 'BUSINESS_CATEGORY'); // 业务场景
        item.deliverypayTypeName = t(item.deliverypayType, dictData, 'DELIVERYPAY_TYPE'); // 运费类型
        item.collectionFlagName = t(item.collectionFlag, dictData, 'COLLECTION_FLAG'); // 是否代收
        item.wmsStatusName = t(item.wmsStatus, dictData, 'WMS_STATUS'); // WMS状态
        item.pickUpName = t(item.pickUp, dictData, 'SCAN_FLAG'); // 是否已扫码提货
        item.professionalCompanyName = t(item.professionalCompany, dictData, 'SYS_PROFESSIONAL_COMPANY'); // 专业公司
        item.handlingStatusName = t(item.handlingStatus, dictData, 'HANDLING_STATUS'); // 是否提供装卸服务
        item.transportationDivisionName = t(item.transportationDivision + '', dictData, 'TRANSPORTATION_DIVISION_TYPE'); // 运输划分标识
        item.distributionFlagName = t(item.distributionFlag, dictData, 'DISTRIBUTION_FLAG'); // 是否分拨订单
        item.distributionLastFlagName = t(item.distributionLastFlag, dictData, 'DISTRIBUTION_LAST_FLAG'); // 是否最后一次分拨
        item.deliveryTypeName = t(item.deliveryType, dictData, 'DELIVERY_TYPE'); // 配送方式
        item.procurementChannelName = t(item.procurementChannel, dictData, 'OTP_TMS_PROCUREMENT_CHANNEL'); // 采购渠道
        item.deliveredVerifyFlagName = t(item.deliveredVerifyFlag, dictData, 'DELIVERED_VERIFY_FLAG'); // 签收类型
        item.carrierVisibleFlagName = t(item.carrierVisibleFlag, dictData, 'CARRIER_VISIBLE_FLAG'); // 是否可见
        item.isIssueName = t(item.isIssue, dictData, 'IS_ISSUE'); // 是否下发零担平台
        item.wmsStatusName = t(item.wmsStatus, dictData, 'WMS_STATUS'); // WMS标识
        item.carrierVisibleFlagName = item.carrierVisibleFlag + ''; // 是否已下发承运商
        item.vipFlag = item.vipFlag + '';
        item.defineStr1JingDongName = item.kaType === 'OFC_JINGDONG' ? item.defineStr1 : ''; // 京东VC单号 kaType === 'OFC_JINGDONG'时 展示
        item.defineStr1TianMaoName = (item.kaType === 'OFC_TMALL' || item.kaType === 'OFC_SUNING') ? item.defineStr1 : ''; // 天猫/苏宁预约单号 kaType === 'OFC_TMALL 或 OFC_SUNING'时 展示
        item.isAllocateWhName = item.isAllocateWh === null ? '已分仓' : (+item.isAllocateWh === 0 ? '未分仓' : '已分仓'); // 是否分仓标识
        item.orderDistinctionFlagName = item.orderDistinctionFlag !== 'CP' ? '是' : '否'; // 是否基地
        item.pickUpStatus = String(item.pickUpStatus);
        item.dispatchMethod = String(item.dispatchMethod);
        // 没有打印记录，即打印次数小于1，则隐藏按钮
        if (!item.printCount || +item.printCount < 1) {
            item.hiddenEvent.push('printLog');
        }
    });
    return data;
};

const t = (key, dict, dicType) => {
    if (!key) return '';
    if (!dict[dicType]) {
        Message.warning(`未获取数据字典: ${dicType}`);
        return key;
    };
    return dict[dicType][key];
};

/**
 * @description 打印前格式化选中数据, 将相同dispatchNo下的customerOrderNo、taskNo合并为数组
 * @param {Array} [{dispatchNo:123, customerOrderNo: 'a', taskNo:1},{dispatchNo:123, customerOrderNo: 'b', taskNo:2}]
 * @returns {Array} [{dispatchNo:123, customerOrderNos: ['a','b'], taskNos:[1,2]}]
 */
const formatPrintData = data => {
    const dispatchMap = new Map();
    data.forEach(item => {
        const { dispatchNo, customerOrderNo, taskNo } = item;
        if (dispatchMap.has(dispatchNo)) {
            const { customerOrderNos, taskNos } = dispatchMap.get(dispatchNo);
            if (!customerOrderNos.includes(customerOrderNo)) {
                customerOrderNos.push(customerOrderNo);
            }
            if (!taskNos.includes(taskNo)) {
                taskNos.push(taskNo);
            }
        } else {
            dispatchMap.set(dispatchNo, {
                customerOrderNos: [customerOrderNo],
                taskNos: [taskNo]
            });
        }
    });
    return Array.from(dispatchMap, ([dispatchNo, { customerOrderNos, taskNos }]) => ({
        dispatchNo,
        customerOrderNos,
        taskNos
    }));
};


const formatLogList = (data, dictData) => {
    if (!data.length) return [];
    data.forEach((item, index) => {
        item.tableIndex = index + 1;
        item.driverPrintName = item.driverPrint === 1 ? '是' : (item.driverPrint === 0 ? '否' : '');
        item.reasonName = dictData.REPEAT_PRINT_REASON[item.reason] || item.reason;
    });
    return data;
};

export { formatSearchData, validateSearchData, validateBind, formatTotalDataList, t, formatPrintData, formatLogList };
